export const state = {
	notifications: [],
	currentUser: {},
};
